import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
} from "@angular/core";

import * as _ from "lodash";

@Component({
  selector: "filter-select-and-inputs",
  templateUrl: "./filter-select-and-inputs.component.html",
  styleUrls: ["./filter-select-and-inputs.component.scss"],
})
export class FilterSelectAndInputsComponent implements OnInit, OnChanges {
  @Input() selectedFilterItem;
  @Input() column;
  @Input() filterColumns;
  @Input() isGroupCriteria: boolean;
  @Input() noFilterObj;
  @Input() betweenObj;
  @Input() greaterThanObj;
  @Input() lessThanObj;
  @Input() equalToObj;
  @Input() filterItems;

  @Output() minChange = new EventEmitter<any>();
  @Output() maxChange = new EventEmitter<any>();
  @Output() singleValChange = new EventEmitter<any>();

  @Output() filterChange = new EventEmitter<any>();

  min;
  max;
  singleVal;
  activeItem;
  metricLabelsForDropdown;

  constructor() {}

  ngOnInit() {
    this.getInitialVals();
  }

  ngOnChanges(change) {
    if (change) {
      if (change.column && change.column.currentValue) {
        if (this.column.metric_labels) {
          // for the dropdowns, we need an array of objects that have a key and a label (we're making the numeric value be the key and the alphaValue be the label)
          this.metricLabelsForDropdown = Object.keys(
            this.column.metric_labels
          ).map((key) => ({
            numericValue: key,
            alphaValue: this.column.metric_labels[key],
          }));
        } else {
          this.metricLabelsForDropdown = null;
        }
      }
      if (change.selectedFilterItem) {
        this.activeItem = change.selectedFilterItem.currentValue;
      }
    }
  }

  filter(event) {
    this.filterChange.emit(event);
    this.minChange.emit(this.min);
    this.maxChange.emit(this.max);
    this.singleValChange.emit(this.singleVal);
  }

  onMinChange($event) {
    this.min = $event;
    this.emitOnMinChangeEvent();
  }

  emitOnMinChangeEvent() {
    if (this.selectedFilterItem == this.betweenObj) {
      this.maxChange.emit(this.max);
    }
    this.minChange.emit(this.min);
    this.filterChange.emit(this.selectedFilterItem);
  }

  onMaxChange($event) {
    this.max = $event;
    this.emitOnMaxChangeEvent();
  }

  emitOnMaxChangeEvent() {
    if (this.selectedFilterItem == this.betweenObj) {
      this.minChange.emit(this.min);
    }
    this.maxChange.emit(this.max);
    this.filterChange.emit(this.selectedFilterItem);
  }

  onSingleValChange($event) {
    this.singleVal = $event;
    this.singleValChange.emit(this.singleVal);
    this.filterChange.emit(this.selectedFilterItem);
  }

  getInitialVals() {
    if (this.filterColumns) {
      let filterColumn = _.find(this.filterColumns, (filterCol) => {
        return filterCol.student_kpi_id == this.column.id;
      });
      if (filterColumn) {
        // if we already have a filter for this column
        if (
          filterColumn["min_value"] != null &&
          filterColumn["max_value"] != null &&
          filterColumn["min_value"] != filterColumn["max_value"]
        ) {
          // if there's a min and a max value and they aren't equal, we're in the between case
          this.min = filterColumn["min_value"];
          this.max = filterColumn["max_value"];
          this.activeItem = this.betweenObj;
        } else {
          // we're either in the single value case (greater than or equal to, less than or equal to, equal to)
          filterColumn["min_value"] != null
            ? (this.singleVal = filterColumn["min_value"])
            : (this.singleVal = filterColumn["max_value"]);
          if (
            filterColumn["min_value"] != null &&
            filterColumn["max_value"] == null
          ) {
            this.activeItem = this.greaterThanObj;
          } else if (
            filterColumn["min_value"] == null &&
            filterColumn["max_value"] != null
          ) {
            this.activeItem = this.lessThanObj;
          } else {
            this.activeItem = this.equalToObj;
          }
        }
      } else {
        this.activeItem = !this.isGroupCriteria ? this.noFilterObj : null;
      }
    } else {
      this.activeItem = !this.isGroupCriteria ? this.noFilterObj : null;
    }
    this.selectedFilterItem = this.activeItem;
    if (!this.isGroupCriteria) {
      this.filterItems = [this.noFilterObj, ...this.filterItems];
    }
  }
}
